import { render, staticRenderFns } from "./corporateProfile.vue?vue&type=template&id=2ac9cded&scoped=true&"
import script from "./corporateProfile.vue?vue&type=script&lang=js&"
export * from "./corporateProfile.vue?vue&type=script&lang=js&"
import style0 from "./corporateProfile.vue?vue&type=style&index=0&id=2ac9cded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac9cded",
  null
  
)

export default component.exports